import { createFileRoute } from "@tanstack/react-router";

import { SalesTeamPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/sales")({
  component: SalesTeamPage,
});
